import { useSelection } from "@/app/department-context"
import { DepartmentListPage } from "../department/department-list-page"
import { NoOrganizationSelected } from "@/component/no-organization-selected"

export const DepartmentsAdminPage = () => {
  const { currentOrganization: organization } = useSelection()
  if (!organization) {
    return <NoOrganizationSelected />
  }
  return <DepartmentListPage organizationId={organization.id} />
}
